import { ButtonComp } from "../../../../components";
import { useAddPrefixMutation } from "../../../../store/admin/settings/companyPrefixSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import PrefixForm from "./PrefixForm";
import { PageTitle } from "../../modules/PageHeaders";
import { useUser } from "../../../../hooks";

export default function CreateCompanyPrefix({ onNext }) {
  const navigate = useNavigate();
  const user = useUser();

  const [addNewPrefix, { isLoading: isSubmittingForm }] =
    useAddPrefixMutation();
  const initialValues = {
    count: "",
    name: "",
    auto_generate: false,
  };

  const handleFormSubmit = async (
    formikValues,
    { setSubmitting, resetForm }
  ) => {
    // Remove branch_id - backend will use active branch automatically
    const reqBody = {
      ...formikValues,
      count: Number(formikValues.count),
      auto_generate: formikValues.auto_generate || false,
    };
    const toastId = toast.loading("Processing");
    try {
      setSubmitting(true);
      const payload = await addNewPrefix(reqBody).unwrap();
      if (payload.status === false) {
        toast.error(payload.message, {
          id: toastId,
        });
      } else {
        toast.success(payload.message, {
          id: toastId,
        });
        resetForm();
      }
    } catch (error) {
      console.log("error", error);
      toast.error(error?.data?.message || "An error occured", { id: toastId });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div>
        <div className="mb-4 text-end">
          <ButtonComp
            btnText={"All Prefixes"}
            onClick={onNext}
            btnClassName="bg-primary1 py-2 px-4 rounded text-white border-0"
          />
        </div>
        <div className="mb-4">
          <PageTitle title={"Cooperative Prefix"} />
        </div>
        <PrefixForm
          initialValues={initialValues}
          handleFormSubmit={handleFormSubmit}
          activeBranchName={user?.active_branch?.name || user?.branch?.name || "Current Branch"}
          isSubmitting={isSubmittingForm}
        />
      </div>
    </>
  );
}
